import React from 'react';
import {Styles} from '../../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from "../../../../../config/Translate";
import TextField from "@material-ui/core/TextField/TextField";
import axios from "axios";
import {defaultVariabls} from "../../../../../config/index";
import {withRouter} from "react-router-dom";
import { withSnackbar } from 'notistack';
import LoadingButton from "../../../../components/elements/LoadingButton";
import Grid from "@material-ui/core/Grid/Grid";
import {connect, setStore} from "trim-redux";
import InputAdornment from "@material-ui/core/InputAdornment/InputAdornment";
import Thumbnail from "../../../fileManager/Components/Thumbnail";
import Alert from "@material-ui/lab/Alert/Alert";
import FormControlLabel from "@material-ui/core/FormControlLabel/FormControlLabel";
import Switch from "@material-ui/core/Switch/Switch";
import withWidth from "@material-ui/core/withWidth/withWidth";
import SaveRoundedIcon from '@material-ui/icons/SaveRounded';
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import FieldCounterWithoutBar from "../../../../components/elements/FieldCounterWithoutBar";
import Link from "@material-ui/core/Link/Link";
import Tabs from "@material-ui/core/Tabs/Tabs";
import Tab from "@material-ui/core/Tab/Tab";
import Button from "@material-ui/core/Button/Button";
import ChevronLeftRoundedIcon from '@material-ui/icons/ChevronLeftRounded';
import SubTitle from "../../../../components/elements/SubTitle";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import ColorPicker from "../../../../components/fields/ColorPicker";
import SingleFileChooser from "../../../fileManager/Components/SingleFileChooser";

class MakeSlideShow extends React.Component {

    state = {
        fields:{
            title:'',
            description:'',
            primary_button_text:'',
            primary_button_icon:'',
            primary_button_link:"",            
            secondary_button_text:'',
            secondary_button_icon:'',
            secondary_button_link:"",
            bg_type:'gradient',
            bg_color:this.props.primary_color,
            bg_color_2:this.props.secondary_color,

        },
        thumbnail: 1,
        bg_image: 1,
        loading: true,
        SubmitLoading: false,
        active: true,
        id:!!this.props.id ? this.props.id : 0,
        editMode:!!this.props.id,
        errors:[],
        tab:"visual"
    };
    classes = this.props.classes;
    async componentDidMount(){
        await this.setState({
            id:this.props.id,
            editMode:!!this.props.id
        })
        if(!!this.props.id) {
            await this.loadData();
        }else{
            this.setState({
                loading:false
            })
        }
    }
    handleThumbImage(id){
        this.setState({
            thumbnail: id
        })
    }
    handleChangeBgImage(file){
        if(!!file){
            this.setState({
                bg_image: file.id
            })
        }

    }
    async loadData(){
        let {id} = this.state;
        let loginToken = localStorage.getItem('ACT');
        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.get(`${defaultVariabls.url}/slideshow/get/${id}`, config)
                .then(response => {
                    this.setState({
                        fields: {
                            title:response.data.title,
                            description:!!response.data.description ? response.data.description : '',
                            primary_button_text:response.data.primary_button_text,
                            primary_button_icon:response.data.primary_button_icon,
                            primary_button_link:response.data.primary_button_link,
                            secondary_button_text:response.data.secondary_button_text,
                            secondary_button_icon:response.data.secondary_button_icon,
                            secondary_button_link:response.data.secondary_button_link,
                            bg_type:response.data.bg_type,
                            bg_color:!!response.data.bg_color ? response.data.bg_color : this.props.primary_color ,
                            bg_color_2:!!response.data.bg_color_2 ? response.data.bg_color_2 : this.props.secondary_color ,
                        },
                        editMode:true,
                        loading:false,
                        thumbnail: response.data.thumbnail.id,
                        bg_image: response.data.bg_image.id,
                        active: response.data.active,
                    })

                }).catch(error => {
                    this.setState({
                        loading:false
                    })
                })
        }else {
            setStore({
                isAuth : false,
                user : null,
            });
        }
    }
    handleChange(e){
        let {errors,fields} = this.state;
        let target = e.target;
        errors[target.name] = "";
        fields[target.name] = target.value;

        this.setState({
            fields,
            errors
        });    
    }

    handleValidation(callback){
        let { fields } = this.state;
        let errors = {};
        let formIsValid = true;

        //title
        if(!fields.title){
            formIsValid = false;
            errors['title'] = Translate.emptyField;
        }
        //Description
        if(fields.description !== null ) {
            if (fields.description.length > 500) {
                formIsValid = false;
                errors['description'] = Translate.maxLength500;
            }
        }
        if(!formIsValid){
            this.props.enqueueSnackbar(Translate.someFieldsHasError, {
                variant: 'warning',
            });
            this.setState({
                errors,
                SubmitLoading:false,
            })
        }
        return callback(formIsValid)
    }
    handleRequest(){
        let { id,fields,thumbnail,bg_image,editMode,active} = this.state;
        let data = new FormData();
        data.append('title', fields.title);
        data.append('description', fields.description);
        data.append('primary_button_text', fields.primary_button_text);
        data.append('primary_button_icon', fields.primary_button_icon);
        data.append('primary_button_link', fields.primary_button_link);
        data.append('secondary_button_text', fields.secondary_button_text);
        data.append('secondary_button_icon', fields.secondary_button_icon);
        data.append('secondary_button_link', fields.secondary_button_link);
        data.append('bg_type', fields.bg_type);
        data.append('bg_color', fields.bg_color);
        data.append('bg_color_2', fields.bg_color_2);
        data.append('thumbnail', thumbnail);
        data.append('bg_image', !!parseInt(bg_image) ? parseInt(bg_image) : 1);
        data.append('id', !!id ? id : 0);
        data.append('active',  active ? 1 : 0);
        data.append('manage',  this.props.manage);

        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariabls.url}/slideshow/make`, data, config)
            .then(response => {
                this.props.enqueueSnackbar(editMode ? Translate.dataEdited : Translate.dataAdded, {
                    variant: 'success',
                });
                this.setState({
                    loading:false,
                    SubmitLoading: false,
                });
                this.props.reload();

            })
            .catch(error => {
                console.log(error.response)
                this.props.enqueueSnackbar(editMode ?  Translate.dataEditingFailed : Translate.dataAddingFailed, {
                    variant: 'error',
                });
                this.setState({
                    loading:false,
                    SubmitLoading: false,
                    SubmitDraftLoading: false
                });
            });

    }

    handleSubmit(e){
        this.setState({
            SubmitLoading: true
        })
        e.preventDefault();
        this.handleValidation((valid) =>{
            if(valid) {
                this.handleRequest();
            }
        });
    }

    handleChangeActive(){
        this.setState({
            active: !this.state.active,
        })
    }
    handleChangeColor(color){
        let {fields}= this.state;
        fields['bg_color'] = color.hex
        this.setState({
            fields
        })
    }
    handleChangeField(field,val){
        let {fields}= this.state;
        fields[field] = val;
        this.setState({
            fields
        })
    }
    render(){
        let {fields, errors,SubmitLoading,thumbnail,tab,active,loading} = this.state;
        let {user} = this.props;
        return (
            <div className="modifySinglePricingHolder">
                {
                    loading ?
                        <div style={{paddingTop:100,paddingBottom:100,textAlign:"center"}}>
                            <CircularProgress size={35}/>
                        </div>
                        :
                        <Grid container spacing={2}  justifyContent="center">
                            <Grid item xs={12} md={10}>
                                <Tabs
                                    value={tab}
                                    onChange={(e,val) => this.setState({tab:val})}
                                    indicatorColor="primary"
                                    textColor="primary"
                                    centered
                                >
                                    <Tab label={Translate.slideShowImages} value="visual"/>
                                    <Tab label={Translate.SlideShowContent} value="content" />
                                </Tabs>
                            </Grid>
                            <>
                            {
                                tab === "visual" ?
                                    <>
                                        <Grid item xs={12}>
                                            <SubTitle align="left">{Translate.mainImageSlide}</SubTitle>
                                            <Thumbnail
                                                simple_full
                                                rounded
                                                handleThumbImage={this.handleThumbImage.bind(this)}
                                                initial={thumbnail}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField
                                                variant="outlined"
                                                value={fields.bg_type}
                                                fullWidth
                                                size="small"
                                                select
                                                label={Translate.bg_type}
                                                name="bg_type"
                                                onChange={this.handleChange.bind(this)}
                                                error = {!!errors['bg_type']}
                                                helperText={errors['bg_type']}
                                            >
                                                <MenuItem value={"gradient"}>
                                                    {Translate.gradientBg}
                                                </MenuItem>
                                                <MenuItem value={"solid"}>
                                                    {Translate.solidBg}
                                                </MenuItem>
                                                <MenuItem value={"image"}>
                                                    {Translate.imageBg}
                                                </MenuItem>
                                            </TextField>
                                        </Grid>
                                        <Grid item xs={12}>
                                            {
                                                fields.bg_type === "solid" ?
                                                    <ColorPicker
                                                        color={fields.bg_color}
                                                        title={Translate.bg_color}
                                                        onChange={(color) => this.handleChangeField('bg_color',color)}
                                                    />
                                                    :
                                                    fields.bg_type === "gradient" ?
                                                        <div>
                                                            <ColorPicker
                                                                color={fields.bg_color}
                                                                title={Translate.gradientBgFirstColor}
                                                                onChange={(color) => this.handleChangeField('bg_color',color)}
                                                            />
                                                            <ColorPicker
                                                                color={fields.bg_color_2}
                                                                title={Translate.gradientBgSecondColor}
                                                                onChange={(color) => this.handleChangeField('bg_color',color)}
                                                            />
                                                        </div>
                                                    :
                                                        <SingleFileChooser
                                                            title={Translate.bg_image}
                                                            onChange={(file) => this.handleChangeBgImage(file)}
                                                        />
                                            }
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Button
                                                endIcon={<ChevronLeftRoundedIcon/>}
                                                onClick={() => this.setState({tab:"content"})}
                                                variant="outlined"
                                                color="primary"
                                            >
                                                {Translate.nextStep}
                                            </Button>
                                        </Grid>
                                    </>
                                :
                                    <>
                                        <Grid item xs={12}>
                                            <Alert
                                                severity="info"
                                                action={
                                                    <FormControlLabel
                                                        style={{marginRight:10}}
                                                        control={
                                                            <Switch
                                                                checked={active}
                                                                onChange={this.handleChangeActive.bind(this)}
                                                                value={active}
                                                                color="primary"
                                                            />
                                                        }
                                                        label={active ? Translate.active : Translate.inactive}
                                                    />
                                                }
                                            >
                                                {Translate.activeStatus}
                                            </Alert>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField
                                                variant="outlined"
                                                value={fields.title}
                                                fullWidth
                                                size="small"
                                                label={Translate.sliderTitle}
                                                name="title"
                                                onChange={this.handleChange.bind(this)}
                                                error = {!!errors['title']}
                                                helperText={errors['title']}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField
                                                variant="outlined"
                                                multiline
                                                minRows={3}
                                                value={fields.description}
                                                fullWidth
                                                size="small"
                                                label={Translate.description}
                                                name="description"
                                                onChange={this.handleChange.bind(this)}
                                                error = {!!errors['description']}
                                                helperText={errors['description']}
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <FieldCounterWithoutBar length={fields.description.length} max={500}/>
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <TextField
                                                variant="outlined"
                                                value={fields.primary_button_icon}
                                                fullWidth
                                                size="small"
                                                label={Translate.primary_button_icon}
                                                name="primary_button_icon"
                                                onChange={this.handleChange.bind(this)}
                                                error = {!!errors['primary_button_icon']}
                                                helperText={errors['primary_button_icon']}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <TextField
                                                variant="outlined"
                                                value={fields.primary_button_text}
                                                fullWidth
                                                size="small"
                                                label={Translate.primary_button_text}
                                                name="primary_button_text"
                                                onChange={this.handleChange.bind(this)}
                                                error = {!!errors['primary_button_text']}
                                                helperText={errors['primary_button_text']}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <TextField
                                                variant="outlined"
                                                value={fields.primary_button_link}
                                                fullWidth
                                                size="small"
                                                label={Translate.primary_button_link}
                                                name="primary_button_link"
                                                onChange={this.handleChange.bind(this)}
                                                error = {!!errors['primary_button_link']}
                                                helperText={errors['primary_button_link']}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <TextField
                                                variant="outlined"
                                                value={fields.secondary_button_icon}
                                                fullWidth
                                                size="small"
                                                label={Translate.secondary_button_icon}
                                                name="secondary_button_icon"
                                                onChange={this.handleChange.bind(this)}
                                                error = {!!errors['secondary_button_icon']}
                                                helperText={errors['secondary_button_icon']}
                                            />

                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <TextField
                                                variant="outlined"
                                                value={fields.secondary_button_text}
                                                fullWidth
                                                size="small"
                                                label={Translate.secondary_button_text}
                                                name="secondary_button_text"
                                                onChange={this.handleChange.bind(this)}
                                                error = {!!errors['secondary_button_text']}
                                                helperText={errors['secondary_button_text']}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <TextField
                                                variant="outlined"
                                                value={fields.secondary_button_link}
                                                fullWidth
                                                size="small"
                                                label={Translate.secondary_button_link}
                                                name="secondary_button_link"
                                                onChange={this.handleChange.bind(this)}
                                                error = {!!errors['secondary_button_link']}
                                                helperText={errors['secondary_button_link']}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Link target="_blank" href="https://fontawesome.com/v5/search">{Translate.iconsList}</Link>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <LoadingButton
                                                startIcon={<SaveRoundedIcon/>}
                                                variant="contained"
                                                color="primary"
                                                onClick = {this.handleSubmit.bind(this)}
                                                loading = {SubmitLoading}
                                            >
                                                {Translate.save}
                                            </LoadingButton>
                                        </Grid>
                                    </>
                            }

                            </>

                        </Grid>
                }

            </div>

        );
    }
}

const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user,
    primary_color: state.primary_color,
    secondary_color: state.secondary_color,
});
export default withWidth()(withRouter(withSnackbar(withStyles(Styles)(connect(mstp)(MakeSlideShow)))));